
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from 'next-themes';
import { Toaster } from '../ui/sonner';
import { 
  PasswordProvider, 
  StudentProvider
} from '@/contexts';
import { NotificationProvider } from '@/contexts/notifications';

// Create a client
const queryClient = new QueryClient();

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <HelmetProvider>
          <ThemeProvider attribute="class" defaultTheme="system">
            <PasswordProvider>
              <NotificationProvider>
                <StudentProvider>
                  <Toaster position="top-right" />
                  {children}
                </StudentProvider>
              </NotificationProvider>
            </PasswordProvider>
          </ThemeProvider>
        </HelmetProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};
